export default __webpack_public_path__ + "static/media/sound.c2110d9d.png";